import type { PaymentPlan } from '../types/payment.types';
import { api } from './api';

export const paymentPlansApi = {
  /**
   * Récupérer le plan de paiement d'une réservation
   */
  getByBookingId: async (bookingId: string): Promise<PaymentPlan | null> => {
    try {
      const response = await api.get(`/payment-plans/booking/${bookingId}`);
      return response.data.data;
    } catch (error: any) {
      if (error.response?.status === 404) {
        return null;
      }
      throw error;
    }
  },
};
